import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsFieldsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-fields',
	path: '/plugins/servlet/project-config/:projectKey/fields',
};
